import { ApiClient } from "./client"
import Vue from "vue"

let client = new ApiClient("/api/")

export default {
  /* Retrouver les guid des questions intéressantes :
  SELECT questions.guid_text, count(answers.guid) as aswers_count, max_chars, event_question_guid
  FROM questions, answers
  WHERE answers.question_guid = questions.guid
  GROUP BY question_guid
  HAVING count(answers.guid) > 21

  30 chars => 7C739996-9413-4F64-8D42-807AC7ACD982 / 0efe060a-0d39-455f-abd1-2e458d54abfb
  120 chars => 83DD4BD0-674A-430F-826E-09930AB55B6C / 4d32b534-ec1f-4bf3-ac35-ab5d42456985
  240 chars => C250AFF4-7617-4583-A7A6-DA2C65BDBEC1 / fb6ca18c-c9eb-4e88-9a6e-12db173c4176
  */

  /*getAnswers (cb) {
    client.get('answers/83DD4BD0-674A-430F-826E-09930AB55B6C').then(response => {
      cb(response.data.answers, response.data.likesMax)
    })
  },*/

  async associateLabel({ guids, question_labels_guid }) {
    try {
      await client.patch("associateLabelToAnswers", { "guids": guids, "question_labels_guid": question_labels_guid })
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de changer le label " + question_labels_guid + " des réponses " + guids.toString(),
      })*/
      console.log(error)
    }
  },

  async updateAnswersOrder({ answers }) {
    try {
      await client.patch("updateAnswersOrder", { "answers": answers })
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de mettre à jour l'ordre des réponses " + JSON.stringify(answers),
      })*/
      console.log(error)
    }
  },

  async updateMergedAnswer({ answer_guid, merged_answer_guid }) {
    try {
      await client.patch("updateMergedAnswer", { "answer_guid": answer_guid, "merged_answer_guid": merged_answer_guid })
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de mettre à jour l'ordre des réponses " + JSON.stringify(answers),
      })*/
      console.log(error)
    }
  },

  async newAnswers(answers) {
    try {
      await client.post("answers", { answers: answers })
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de d'ajouter les réponses " + JSON.stringify(answers),
      })*/
      console.log(error)
    }
  },

  async newAnswer(answer) {
    try {
      await client.post("answer", answer)
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de d'ajouter la réponse " + JSON.stringify(answer),
      })*/
      console.log(error)
    }
  },

  // POST instead of DELETE to let pass data to the request
  async deleteAnswers(guids) {
    try {
      await client.post("deleteAnswers", { guids: guids })
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de supprimer les réponses " + guids.toString(),
      })*/
      console.log(error)
    }
  },
}
